import { render, staticRenderFns } from "./AddLessons.vue?vue&type=template&id=f72c9fbe&"
import script from "./AddLessons.vue?vue&type=script&lang=js&"
export * from "./AddLessons.vue?vue&type=script&lang=js&"
import style0 from "./AddLessons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddLessons.vue"
export default component.exports